import { AnalysisFileType } from "../../../types/analysisFileTypes";
import GenericAnalysisFilesPage from "./GenericAnalysisFilesPage";


export default function NewEmployeesAnalysisFilesPage() {
    return <GenericAnalysisFilesPage
        fileType={AnalysisFileType.NewEmployeesAnalysisFile}
        title={"analysisPage.newEmployees.title"}
    />
}